var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",attrs:{"cmpt":"LabelRow"}},[(_vm.left)?_c('div',{class:_vm.leftPadding}):_vm._e(),_c('div',{class:_vm.middle},[_vm._v(" "+_vm._s(_vm.MC.get(_vm.label))+" ")]),(_vm.right)?_c('div',{class:_vm.rightPadding}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }